/* eslint-disable camelcase */
export default {
  title: "Basic info",
  profile_updated: "Profile updated successfully",
  unknown_error: "Unknown error occurred while editing profile",
};
